import WorkCard from "./WorkCard";

const Work = () => {
  return (
    <section id="work">
      <h1 className="work-heading">
        <i className="fa-solid fa-code"></i>
        <span>Projects</span>
      </h1>
      <div className="work-content"data-aos="fade-down" >
        <WorkCard
          title="Book My Stay"
          content="Check Hotels and book rooms according to availability (Clone of Booking.com) :
          • Tech Used - React, JavaScript, NodeJS, Express, MongoDB"
          image="../../images/Book My Stay.png"
          github="https://github.com/abhi-43/BookMyStay-frontend"
          live="https://abhishek-bookmystay.netlify.app/"
        />
        <WorkCard
          title="Crypto Pedia"
          content="Displays all crypto prices details with watchlist and price change charts features.:
          • Tech Used - HTML, CSS, JS, ReactJS, FireBase, ChartJS"
          image="../../images/Crypto.png"
          github="https://github.com/abhi-43/Crypto-Pedia"
          live="https://abhishek-crypto-pedia.netlify.app/"
        />

        <WorkCard
          title="Code Sync"
          content="Realtime Code Share Editor to work with friends. : • Tech Used - React, JavaScript, Socket.io, NodeJS"
          image="../../images/Code_sync.png"
          github="https://github.com/abhi-43/codesync-frontend"
          live="https://abhishek-codesync.netlify.app/"
        />

        <WorkCard
          title="Moviz"
          content="MERN project to search movies create public & private playlist and add after authentication. : • Tech Used - React, JavaScript, MongoDB, NodeJS, Express"
          image="../../images/Moviz.png"
          github="https://github.com/abhi-43/Moviz-frontend-task"
          live="https://moviz-web.herokuapp.com/"
        />

         <WorkCard
          title="Insta Reels Clone"
          content="Users can upload reels, view existing users reel videos, like and comment on posts. :
          • Tech Used - HTML, CSS, JS, ReactJS, FireBase, Material UI."
          image="../../images/Insta.png"
          github="https://github.com/abhi-43/Insta-Reels"
          live="https://abhishek-reels-app.netlify.app/"
        />
         <WorkCard
          title="JIRA Ticket Manager"
          content="Website to manage tickets on priority colour basis with filter and lock features :
          • Tech Used - HTML, CSS, JavaScript"
          image="../../images/JIRA.png"
          github="https://github.com/abhi-43/Jira-Ticket-Manager"
          live="https://abhishek-jira-ticket-manager.netlify.app/"
        />

        <WorkCard
          title="E-Library Management System"
          content="Maintain admin and member records, book
          records and transactions digitally. :
          • Tech Used - HTML, CSS, JS, BootStrap, ASP.NET with MS-SQL"
          image="../../images/library.png"
          github="https://github.com/abhi-43/E-Library-Management"
          live="https://github.com/abhi-43/E-Library-Management/blob/master/README.md"
        />

        <WorkCard
          title="Music Player"
          content="Listen Music Online. : • Tech Used - HTML, CSS, JavaScript"
          image="../../images/MusicPlayer.jpg.png"
          github="https://github.com/abhi-43/Music-Player"
          live="https://muzik-player.herokuapp.com/"
        />

        <WorkCard
          title="Portfolio"
          content="Personal Portfolio. : • Tech Used - ReactJS, JavaScript"
          image="../../images/Portfolio.png"
          github="https://github.com/abhi-43"
          live="https://abhishek43.vercel.app/"
        />
      </div>
    </section>
  );
};

export default Work;
